import PersistentDrawerLeft from "../../components/NewDrawer";
import Loading from "../../components/Loading";
import React, {useEffect, useRef, useState} from "react";
import {Stock} from "../../components/charts/LineChart";
import {DateRangePicker, LicenseInfo} from '@mui/x-date-pickers-pro';
import {Button, Stack, TextField, Typography} from "@mui/material";
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers-pro';
import locale from 'date-fns/locale/hu'
import {formatHuman} from "../../utils/utils";
import useCallDataApi from "../../hooks/data";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import DinoDialog from "../../components/Dialog";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import RxStockData from "./RxStockData";
import TxStockData from "./TxStockData";

const Stocks = () => {
    const [loading, setLoading] = useState(false)
    const [rxDialogOpen, setRxDialogOpen] = useState(false)
    const [txDialogOpen, setTxDialogOpen] = useState(false)
    const [receivers, setReceivers] = useState([])
    const [transmitters, setTransmitters] = useState([])
    const [rxStock, setRxStock] = useState([])
    const [txStock, setTxStock] = useState([])
    const [selectedDateRange, setSelectedDateRange] = useState([new Date(), new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)])
    const {getData: getReceivers} = useCallDataApi('receivers')
    const {getData: getTransmitters} = useCallDataApi('transmitters')
    const {postData: postRxStock, createData: createRxStock} = useCallDataApi('rx-stock')
    const {postData: postTxStock, createData: createTxStock} = useCallDataApi('tx-stock')

    const rxReference = useRef(null)
    const txReference = useRef(null)

    useEffect(() => {
        setLoading(true)
        Promise.all([
            getReceivers(),
            getTransmitters(),
            postRxStock('get_for_date_range', {
                start_date: formatHuman(selectedDateRange[0]),
                end_date: formatHuman(selectedDateRange[1])
            }),
            postTxStock('get_for_date_range', {
                start_date: formatHuman(selectedDateRange[0]),
                end_date: formatHuman(selectedDateRange[1])
            }),
        ])
            .then(([rx, tx,  rx_stock, tx_stock]) => {
                setReceivers(rx)
                setTransmitters(tx)
                setRxStock(rx_stock)
                setTxStock(tx_stock)
            })
            .finally(() => setLoading(false))
    }, [selectedDateRange])

    const handleDateChange = (newValue) => {
        if (newValue[0] && newValue[1]) {
            setSelectedDateRange(newValue);
        }
    };

    LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY)

    return (
        <PersistentDrawerLeft title="Készletek" buttons={[
            <Button
                variant='outlined'
                key='b1'
                endIcon={<AddCircleOutlineRoundedIcon/>}
                onClick={() => setRxDialogOpen(true)}
                color='success'
            >
                Vevő készlet
            </Button>,
            <Button
                variant='outlined'
                key='b2'
                endIcon={<AddCircleOutlineRoundedIcon/>}
                onClick={() => setTxDialogOpen(true)}
                color='success'
            >
                Adó készlet
            </Button>
        ]}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale} localeText={{start: 'Kezdete', end: 'Vége'}}>
                <DateRangePicker
                    value={selectedDateRange}
                    onChange={handleDateChange}
                    renderInput={(startProps, endProps) => (
                        <Stack spacing={2} direction={{xs: 'column', md: 'row'}}>
                            <TextField {...startProps} />
                            <TextField {...endProps} />
                        </Stack>
                    )}
                />
            </LocalizationProvider>

            <Typography variant='h6' gutterBottom>Vevő készlet</Typography>
            <Stock stockData={rxStock} receivers={receivers}/>

            <Typography variant='h6' gutterBottom>Adó készlet</Typography>
            <Stock stockData={txStock} receivers={transmitters}/>

            <Loading isLoading={loading}/>

            <DinoDialog
                handleClose={() => setRxDialogOpen(false)}
                actions={<Stack direction='row' spacing={2} marginRight={2} marginBottom={2}>
                    <Button size='large' variant='outlined'
                            onClick={() => setRxDialogOpen(false)}>Mégsem</Button>
                    <Button size='large' variant='outlined' color='success' disabled={!rxDialogOpen} onClick={() => {
                        const stock = rxReference.current.getData()
                        if (stock) {
                            setRxDialogOpen(false)
                            setLoading(true)
                            createRxStock(stock)
                                .then(s => setSelectedDateRange([...selectedDateRange]))
                                .finally(() => setLoading(false))
                        }
                    }} endIcon={<SaveRoundedIcon/>}>Mentés</Button>
                </Stack>}
                open={rxDialogOpen}
                title='Készlet módosítása'
                subtitle='Selejtezéshez negatív számot írjon be, vásárlás/hozzáadás esetén pozitívat'
            >
                <RxStockData reference={rxReference} />
            </DinoDialog>

            <DinoDialog
                handleClose={() => setTxDialogOpen(false)}
                actions={<Stack direction='row' spacing={2} marginRight={2} marginBottom={2}>
                    <Button size='large' variant='outlined'
                            onClick={() => setTxDialogOpen(false)}>Mégsem</Button>
                    <Button size='large' variant='outlined' color='success' disabled={!txDialogOpen} onClick={() => {
                        const stock = txReference.current.getData()
                        if (stock) {
                            setTxDialogOpen(false)
                            setLoading(true)
                            createTxStock(stock)
                                .then(s => setSelectedDateRange([...selectedDateRange]))
                                .finally(() => setLoading(false))
                        }
                    }} endIcon={<SaveRoundedIcon/>}>Mentés</Button>
                </Stack>}
                open={txDialogOpen}
                title='Készlet módosítása'
                subtitle='Selejtezéshez negatív számot írjon be, vásárlás/hozzáadás esetén pozitívat'
            >
                <TxStockData reference={txReference} />
            </DinoDialog>
        </PersistentDrawerLeft>
    );
};

export default Stocks;
